module.exports = __webpack_public_path__ + "img/profile.278ab214.svg";